import { render, staticRenderFns } from "./InitializeLicenses.vue?vue&type=template&id=2500a69c&"
import script from "./InitializeLicenses.vue?vue&type=script&lang=js&"
export * from "./InitializeLicenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports